import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Row, Col, Typography, Input, Button, Spin, Card, Space } from 'antd'
import { LoadingOutlined, CloudOutlined, KeyOutlined, DatabaseOutlined } from '@ant-design/icons'
import { createUpdateDashboardServices, getDashboardServices } from '../../../Redux/Services/Administrator/Dashboard'
import { 
    storePowerBIPublic, 
    storePowerBIPrivate, 
    storeDatasetId 
} from '../../../Redux/Reducers/Administrator/Dashboard'
import '../../../Styles/Routes/Administrator/AdminDeck/AdminDeck.css'

const AdminDeck = () => {
    const { Title } = Typography

    const { 
        rex_powerbi_public,
        rex_powerbi_private,
        rex_dataset_id,
	} = useSelector(state => state.dashboard)

    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    const dashboardData = useQuery({
		queryKey: ['dashboard'],
		queryFn : () => getDashboardServices(dispatch),
		retry: 1,
		refetchOnWindowFocus : false,
	})

    const mutateDashboard = useMutation({
		mutationFn: () => createUpdateDashboardServices(
            rex_powerbi_public, // Usar como legacy si es necesario
            true, // Estado por defecto
            rex_powerbi_public,
            rex_powerbi_private,
            rex_dataset_id
        ),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['dashboard'] })
        }
	})

	return (
		<div style={{ padding: '24px', background: '#f5f5f5', minHeight: '100vh' }}>
            <Row justify="center">
                <Col xs={24} sm={22} md={20} lg={16} xl={12}>
                    <Card
                        title={
                            <div style={{ textAlign: 'center', padding: '16px 0' }}>
                                <Title level={2} style={{ margin: 0, color: '#4A90E2' }}>
                                    <DatabaseOutlined style={{ marginRight: 8 }} />
                                    Configuración Power BI
                                </Title>
                                <p style={{ color: '#8c8c8c', margin: '8px 0 0 0', fontSize: '14px' }}>
                                    Gestiona los enlaces y configuraciones del dashboard
                                </p>
                            </div>
                        }
                        style={{ 
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            borderRadius: '8px',
                        }}
                        bodyStyle={{ padding: '32px' }}
                    >
                        <Space direction="vertical" size="large" style={{ width: '100%' }}>
                            
                            {/* Power BI Público */}
                            <div>
                                <Title level={5} style={{ marginBottom: 8, color: '#595959' }}>
                                    <CloudOutlined style={{ marginRight: 8 }} />
                                    Power BI Público
                                </Title>
                                <Spin spinning={dashboardData.isLoading}>
                                    <Input 
                                        size="large"
                                        placeholder="https://app.powerbi.com/view?r=eyJr... (Tab Lectura)"
                                        onChange={(e) => dispatch(storePowerBIPublic(e.target.value))}
                                        value={rex_powerbi_public}
                                        prefix={<CloudOutlined style={{ color: '#8c8c8c' }} />}
                                    />
                                </Spin>
                            </div>

                            {/* Power BI Privado */}
                            <div>
                                <Title level={5} style={{ marginBottom: 8, color: '#595959' }}>
                                    <KeyOutlined style={{ marginRight: 8 }} />
                                    Power BI Privado
                                </Title>
                                <Spin spinning={dashboardData.isLoading}>
                                    <Input 
                                        size="large"
                                        placeholder="Token de autenticación (Tab Descarga)"
                                        onChange={(e) => dispatch(storePowerBIPrivate(e.target.value))}
                                        value={rex_powerbi_private}
                                        prefix={<KeyOutlined style={{ color: '#8c8c8c' }} />}
                                    />
                                </Spin>
                            </div>

                            {/* Dataset ID */}
                            <div>
                                <Title level={5} style={{ marginBottom: 8, color: '#595959' }}>
                                    <DatabaseOutlined style={{ marginRight: 8 }} />
                                    Dataset ID
                                </Title>
                                <Spin spinning={dashboardData.isLoading}>
                                    <Input 
                                        size="large"
                                        placeholder="3df7e639-2679-4971-b31c-6b43acfc11b0"
                                        onChange={(e) => dispatch(storeDatasetId(e.target.value))}
                                        value={rex_dataset_id}
                                        prefix={<DatabaseOutlined style={{ color: '#8c8c8c' }} />}
                                    />
                                </Spin>
                            </div>

                            {/* Botón de guardar */}
                            <Button
                                type="primary"
                                size="large"
                                block
                                onClick={() => mutateDashboard.mutate()}
                                loading={mutateDashboard.isPending}
                                style={{ 
                                    height: '48px',
                                    fontSize: '16px',
                                    marginTop: '24px',
                                    background: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)',
                                    border: 'none',
                                    boxShadow: '0 4px 12px rgba(74, 144, 226, 0.25)',
                                    borderRadius: '6px'
                                }}
                            >
                                Guardar Configuración
                            </Button>
                        </Space>
                    </Card>
                </Col>
            </Row>
        </div>
	)
}

export default AdminDeck